<template>
  <v-container fluid>
    <v-row>
      <v-col :md="3">
        <v-btn text @click="$router.go(-1)" class="mb-8"
          ><v-icon dark left>mdi-arrow-left</v-icon> Назад</v-btn
        >
        <dress-card :item="dress" />
      </v-col>
      <v-col :md="9">
        <calendar
          :events="dress.events"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import DressCard from "../components/DressCard";
import Calendar from "../components/Calendar";

export default {
  components: {
    DressCard,
    Calendar
  },
  mounted() {
    this.$store.dispatch("findOneDress", this.$route.params.id);
  },
  computed: {
    dress: function() {
      return this.$store.getters.oneDress;
    }
  }
};
</script>

<style lang="scss">
@import "~@fullcalendar/core/main.css";
@import "~@fullcalendar/daygrid/main.css";

.fs-1 {
  flex-shrink: 1;
  flex-grow: 0;
}
</style>
